<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'MatchesDataProvider',
  created() {
    this.fetchItems();
  },
  methods: {
    ...mapActions('Matches', ['fetchItems', 'refresh'])
  },
  computed: {
    ...mapGetters('Matches', [
      'getMatches',
      'isLoading',
      'failed',
      'matchCount'
    ])
  },
  render() {
    return this.$scopedSlots.default({
      matches: this.getMatches,
      matchCount: this.matchCount,
      loading: this.isLoading,
      failed: this.failed,
      refresh: this.refresh
    });
  }
};
</script>
